import {TrackingStatus} from '../hooks/useStatus'

export default function isCompleted(status: TrackingStatus) {
  return ['done', 'archived'].includes(status)
}
